import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
// Add timeout
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/delay';

import * as Config from '../../app/app.config';
// import { AuthProvider } from '../auth/auth';
// import { ProofProvider } from '../proof/proof';
// import { MediaProvider } from '../../providers/media/media';
// import { FileProvider } from '../../providers/file/file';
import {Storage} from '@ionic/storage';
// import { Platform } from 'ionic-angular';
// import { File } from '@ionic-native/file';
// import { Transfer, FileUploadOptions, TransferObject } from '@ionic-native/transfer';

// import { SendingStatus } from '../../models/sendingstatus';
// import { MediaItem } from '../../models/mediaitem';

/*
  Generated class for the AddressServerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class AddressServerProvider {

  // private medias: MediaItem[];
  // private mediasSuccess: any[];

  constructor(
    private http: Http,
    // private auth: AuthProvider,
    // private proofProvider: ProofProvider,
    private storage: Storage,
    // private platform: Platform,
    // private mediaProvider: MediaProvider,
    // private file: File,
    // private fileProvider: FileProvider
  ) {
    console.log('Hello AddressServerProvider Provider');
  }

  searchByZip(zipCode: string) {
    let that = this;

    return Observable.create((observer: any) => {
      console.log('Searching by zipcode: ' + zipCode);

      // that.storage.get('userproof_' + id).then((value: any) => {
      //   if (value) {
      //     observer.next(JSON.parse(value));
      //     observer.complete();
      //   } else {
      //let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/address/zip/' + zipCode, {headers: null})
        .timeout(30 * 1000)
        .map((res: Response) => res.json())
        .subscribe((data) => {
          // that.storage.set('userproof_' + id, JSON.stringify(data));
          // that.storage.set('userproof_' + id + '_duration', data.duration * 60);
          // that.storage.set('userproof_' + id + '_currentquestion_idx', -1);

          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
      //  }
      // }).catch((error: any) => {
      //   observer.error(new Error(error.status));
      // });
    });
  }

  fetchCities(state: string) {
    let that = this;

    return Observable.create((observer: any) => {
      console.log('Fetching cities of state: ' + state);

      that.http.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + state + '/microrregioes', {headers: null})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /*
    fetch(id: number) {
      let that = this;

      return Observable.create(observer => {
        console.log('Fetching proof: ' + id);

        that.storage.get('userproof_' + id).then((value: any) => {
          if (value) {
            observer.next(JSON.parse(value));
            observer.complete();
          } else {
            let headers = that.auth.createApplicationHeadersWithBearer();

            that.http.get(Config.baseUrl + '/proofs/' + id, { headers: headers })
              .map((res: Response) => res.json())
              .subscribe((data) => {
                that.storage.set('userproof_' + id, JSON.stringify(data));
                that.storage.set('userproof_' + id + '_duration', data.duration * 60);
                that.storage.set('userproof_' + id + '_currentquestion_idx', -1);

                observer.next(data);
                observer.complete();
              }, (error: any) => {
                observer.error(new Error(error.status));
              });
          }
        }).catch((error: any) => {
          observer.error(new Error(error.status));
        });
      });
    }

    send(id: number, sendingStatus: SendingStatus, onFinish: any) {
      console.log('server.send');
      let that = this;

      console.log(sendingStatus);
      if (sendingStatus) {
        sendingStatus.active = true;
        sendingStatus.answers.active = true;
        sendingStatus.answers.progress = false;
      }

      this.proofProvider.getAnswersAndSituations().subscribe((promises: Promise<any>[]) => {
        console.log('server.send.proofProvider.getAnswersAndSituations', promises);

        Promise.all(promises).then((values: string[]) => {
          let identificationAnswers = [];
          let answers = [];
          let situations = [];

          values.forEach((value: string) => {
            let obj = JSON.parse(value);

            if (typeof obj.kind !== 'undefined') {
              switch (obj.kind) {

                case 'IQTA':
                  identificationAnswers.push(obj);
                  break;

                case 'QTA':
                  answers.push(obj);
                  break;

                case 'QTS':
                  situations.push(obj);
                  break;

              }
            }
          });

          let data = {
            identificationAnswers: identificationAnswers,
            answers: answers,
            situations: situations
          };

          console.log(data);

          let headers = that.auth.createApplicationHeadersWithBearer();

          that.http.post(Config.baseUrl + '/proofs/' + id, data, { headers: headers }).subscribe((response: Response) => {
            console.log(response);

            let data = response.json();
            console.log(data);

            if (data.error) {
              if (sendingStatus) {
                sendingStatus.error = true;
                sendingStatus.errorMessage = data.error.message;
              }
            } else {
              if (sendingStatus) {
                sendingStatus.answers.done = true;
              }

              // DONE: Fix error cordova_not_available
              if (that.platform.is('cordova')) {

                if (sendingStatus) {
                  sendingStatus.files.active = true;
                  sendingStatus.files.progress = false;
                }

                // let medias = that.media.getMedias();
                // let mediasTotal = medias.length;
                let iMedia = -1;
                // let mediaPercent = 0;
                let currentMedia = null;

                // console.log('Medias', medias);

                //that.sendMedias(id, medias, (event: any) => {
                that.sendMedias(id, (event: any) => {
                  console.log('In progress');
                  console.log(event);
                }, (sucessos: any) => {
                  console.log('Successful');
                  console.log(sucessos);

                  if (sendingStatus) {
                    sendingStatus.files.done = true;
                  }

                  if (sendingStatus) {
                    sendingStatus.finishing.active = true;
                  }

                  that.http.get(Config.baseUrl + '/proofs/' + id + '/finished', { headers: headers }).subscribe((response: Response) => {
                    console.log(response);

                    let data = response.json();
                    console.log(data);

                    that.removeStoredData(id);

                    if (sendingStatus) {
                      sendingStatus.finishing.done = true;
                    }

                    if (sendingStatus) {
                      sendingStatus.done = true;
                    }

                    if (onFinish) {
                      onFinish(sendingStatus);
                    }
                  }, (error: any) => {
                    console.log(error);

                    if (sendingStatus) {
                      sendingStatus.error = true;
                    }

                    if (onFinish) {
                      onFinish(sendingStatus);
                    }
                  });

                }, (error: any) => {
                  console.log('Something is wrong');
                  console.log(error);

                  if (sendingStatus) {
                    sendingStatus.error = true;
                  }

                  if (onFinish) {
                    onFinish(sendingStatus);
                  }
                }, (media: MediaItem) => {
                  console.log('Media changed', media);
                  if (currentMedia != null) {
                    console.log('It must be remove the media');
                  }

                  if (media) {
                    currentMedia = media;
                    iMedia++;
                    console.log('New media to send', iMedia, media);
                  }
                });
              } else {
                if (sendingStatus) {
                  sendingStatus.finishing.active = true;
                }

                that.http.get(Config.baseUrl + '/proofs/' + id + '/finished', { headers: headers }).subscribe((response: Response) => {
                  console.log(response);

                  let data = response.json();
                  console.log(data);

                  that.removeStoredData(id);

                  if (sendingStatus) {
                    sendingStatus.finishing.done = true;
                  }

                  if (sendingStatus) {
                    sendingStatus.done = true;
                  }

                  if (onFinish) {
                    onFinish(sendingStatus);
                  }
                }, (error: any) => {
                  console.log(error);

                  if (sendingStatus) {
                    sendingStatus.error = true;
                  }

                  if (onFinish) {
                    onFinish(sendingStatus);
                  }
                });
              }
            }
          }, error => {
            console.log(error);

            if (sendingStatus) {
              sendingStatus.error = true;
            }
          });
        }).catch((error: any) => {
          console.log('server.send.proofProvider.getAnswers.promises', error);
        });
      }, (error: any) => {
        console.log('server.send.proofProvider.getAnswers.error', error);
      });

      // let data = {
      //   // answers: this.proofProvider.getAnswers()
      // };

      // // Fire and forget
      // this.storage.keys().then((keys: string[]) => {
      //   for (let k = 0; k < keys.length; k++) {
      //     if (keys[k].includes('userproof_' + id)) {
      //       that.storage.remove(keys[k]);
      //     }
      //   }
      //   // this.storage.remove('userproof_' + id);
      //   // this.storage.remove('userproof_' + id + '_status');
      //   // this.storage.remove('userproof_' + id + '_answers');
      //   // this.storage.remove('userproof_' + id + '_files');
      // });
    }

    sendQuestionAnswer(id: number, kind: string, questionId: any, answerId: any) {
      console.log('Sending question answer proof: ' + id);
      console.log('  + kind: ' + kind);
      console.log('  + questionId: ' + questionId);
      console.log('  + answerId: ' + answerId);

      let headers = this.auth.createApplicationHeadersWithBearer();

      return this.http.get(Config.baseUrl + '/proofs/' + id + '/question/' + kind + '/' + questionId + '/' + answerId, { headers: headers })
        .map((res: Response) => res.json())
    }

    private sendMediaItem(id: number, onProgress: any, onSuccess: any, onFail: any, onNextItem: any) {
      let that = this;

      if (this.medias.length > 0) {
        let media = this.medias.shift();

        console.log('Sending media');
        console.log(media);

        if (onNextItem) {
          console.log('server.sendMedias.hasNextItem');
          onNextItem(media);
        }

        // If it is on APP and it's not Base64 content
        if ((this.platform.is('cordova')) && (!media.base64)) {
          let fileTransfer: TransferObject = (new Transfer()).create();

          // Bind the progress function
          fileTransfer.onProgress(onProgress);

          // Prepare our upload options
          let options = <FileUploadOptions>{
            fileKey: 'file',
            fileName: media.contentOrPath.split('/').pop(),
            // mimeType: 'image/jpeg',
            chunkedMode: false,
            headers: {
              'Content-Type': undefined,
              'Authorization': 'Bearer ' + this.auth.getToken()
            },
            params: {
              questionId: null,
              note: null,
              captured: null,
              seconds: null,
              secondsRemaining: null
            }
          };

          if (media.id) {
            options.params.id = media.id;
          }

          if (media.questionId) {
            options.params.questionId = media.questionId.toString();
          }

          if (media.note) {
            options.params.note = media.note;
          }

          if (media.captured) {
            options.params.captured = media.captured;
          }

          if (media.seconds) {
            options.params.seconds = media.seconds.toString();
          }

          if (media.secondsRemaining) {
            options.params.secondsRemaining = media.secondsRemaining.toString();
          }

          // TODO: Verify if file really exists
          let transferFilePath = encodeURI(media.contentOrPath);
          let transferTargetUrl = encodeURI(Config.baseUrl + '/proofs/' + id + '/file/' +
            this.fileProvider.extractName(media.contentOrPath) + '/' + media.kind);

          fileTransfer.upload(
            transferFilePath,
            transferTargetUrl,
            options,
            false
          ).then((data) => {
            let dataResponse = JSON.parse(data.response);

            if (data.responseCode === 200) {
              // onSuccess(data);
              console.log('Media was sent');
              console.log(dataResponse);

              console.log('Remove media');
              that.storage.get('userproof_' + id + '_file_' + dataResponse.response.id).then((value: string) => {
                let item = <MediaItem>JSON.parse(value);

                that.storage.remove('userproof_' + id + '_file_' + dataResponse.response.id);

                // Try to remove old and big file
                that.file.resolveLocalFilesystemUrl(item.contentOrPath).then(entry => {
                  console.log('Stored file ' + entry.name);
                  entry.remove(() => {
                    console.log('Deleted');
                  }, e => console.log(e));
                }).catch(e => console.log(e));
              });

              that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
            } else {
              onFail({
                code: data.responseCode,
                response: dataResponse
              });
            }
          }, (error) => {
            console.log(error);
            console.log('transfer error source ' + error.source);
            console.log('transfer error target ' + error.target);
            console.log('transfer error code ' + error.code);

            // If error.code equals to FILE_NOT_FOUND_ERR
            if (error.code === 1) {
              that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
            } else {
              onFail(error);
            }
          });
        } else {
          // TODO: Serve this form to mobile too
          let formData: FormData = new FormData();
          let xhr: XMLHttpRequest = new XMLHttpRequest();

          if (!media.name) {
            media.name = this.fileProvider.generateName();
          }

          // Is Web
          // TODO: Better way to retrieve type, or do not set the extension (need to try)
          // if (!this.platform.is('cordova')) {
          media.name += '.jpg';
          // }

          // Is Web
          // TODO: Better way read content, detect if it is base64 or something else
          // if (!this.platform.is('cordova')) {
          let base64ImageContent = media.contentOrPath.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
          let blob = this.fileProvider.base64ToBlob(base64ImageContent, 'image/jpeg');
          formData.append('file', blob, media.name);
          // } else {

          // }

          if (media.id) {
            formData.append('id', media.id);
          }

          if (media.questionId) {
            formData.append('questionId', media.questionId.toString());
          }

          if (media.note) {
            formData.append('note', media.note);
          }

          if (media.captured) {
            formData.append('captured', media.captured);
          }

          if (media.seconds) {
            formData.append('seconds', media.seconds.toString());
          }

          if (media.secondsRemaining) {
            formData.append('secondsRemaining', media.secondsRemaining.toString());
          }

          let transferTargetUrl = encodeURI(Config.baseUrl + '/proofs/' + id + '/file/' + media.name + '/' + media.kind);

          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                // observer.next(JSON.parse(xhr.response));
                //observer.complete();

                let data = JSON.parse(xhr.response);

                console.log('Media was sent');
                console.log(data);

                console.log('Remove media');
                that.storage.remove('userproof_' + id + '_file_' + data.response.id);

                that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
              } else {
                console.log(xhr);

                if (onFail) {
                  onFail(xhr);
                }
              }
            }
          };

          xhr.upload.onprogress = (event) => {
            // console.log(event);
            if (event.lengthComputable) {
              // console.log(Math.round(event.loaded / event.total * 100));
              // this.progress = Math.round(event.loaded / event.total * 100);

              // this.progressObserver.next(this.progress);
            }
          };

          xhr.open('POST', transferTargetUrl, true);
          xhr.setRequestHeader('Authorization', 'Bearer ' + this.auth.getToken());
          xhr.send(formData);
        }
      } else if (onSuccess) {
        onSuccess([]);// this.mediasSuccess);
      }
    }

    sendMedias(id: number, onProgress: any = null, onSuccess: any = null, onFail: any = null, onNextItem: any = null) {
      console.log('server.sendMedias');
      let that = this;

      this.mediaProvider.getMedias().subscribe((promises: Promise<any>[]) => {
        console.log('server.send.mediaProvider.getMedias', promises);

        Promise.all(promises).then((values: string[]) => {
          that.medias = [];
          values.forEach((value: string) => {
            that.medias.push(JSON.parse(value));
          });

          that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
        }).catch((error: any) => {
          console.log('server.send.mediaProvider.getMedias.promises', error);
        });
      }, (error: any) => {
        console.log('server.send.mediaProvider.getMedias.error', error);
      });
    }

    private removeStoredData(id: number) {
      let that = this;

      // Destroy current proof
      this.proofProvider.destroy();

      // Fire and forget
      this.storage.keys().then((keys: string[]) => {
        for (let k = 0; k < keys.length; k++) {
          if (keys[k].includes('userproof_' + id)) {
            that.storage.remove(keys[k]);
          }
        }
      });
    }

    fetchFinisheds() {
      let that = this;

      return Observable.create(observer => {
        let headers = that.auth.createApplicationHeadersWithBearer();

        that.http.get(Config.baseUrl + '/proofs/finisheds', { headers: headers })
          .map((res: Response) => res.json())
          .subscribe((data) => {
            observer.next(data);
            observer.complete();
          }, (error: any) => {
            observer.error(new Error(error.status));
          });
      });
    }

    fetchResponseFeedback(id: number) {
      let that = this;

      return Observable.create(observer => {
        let headers = that.auth.createApplicationHeadersWithBearer();

        that.http.get(Config.baseUrl + '/proofs/' + id + '/response/feedback', { headers: headers })
          .map((res: Response) => res.json())
          .subscribe((data) => {
            observer.next(data);
            observer.complete();
          }, (error: any) => {
            observer.error(new Error(error.status));
          });
      });
    }

    unlock(id: number) {
      let that = this;

      return Observable.create(observer => {
        console.log('Unlocking proof: ' + id);

        let headers = that.auth.createApplicationHeadersWithBearer();

        that.http.get(Config.baseUrl + '/proofs/' + id + '/unlock', { headers: headers })
          .map((res: Response) => res.json())
          .subscribe((data) => {
            console.log(data);
            // that.storage.set('userproof_' + id, JSON.stringify(data));
            // that.storage.set('userproof_' + id + '_duration', data.duration * 60);
            // that.storage.set('userproof_' + id + '_currentquestion_idx', -1);

            //that.removeStoredData(id);

            observer.next(data);
            observer.complete();
          }, (error: any) => {
            observer.error(new Error(error.status));
          });
      });
    }
    */

}



// WEBPACK FOOTER //
// ./src/providers/address-server/address-server.ts